// extracted by mini-css-extract-plugin
export var container = "_5l-0";
export var containerTopRight = "_5l-1";